import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import { FrontMenuProductDynamicDataList } from './models';
import * as MutationTypes from './mutationTypes';

const menuProductDynamicDataListSuccess = (state, payload) => {
  state.frontMenuProductDynamicDataList = payload;
};

const applyChanges = (state, { mpddOrderChanges, mpddSpecialChanges, mpddIsVisibleChanges }) => {
  if (state.frontMenuProductDynamicDataList instanceof FrontMenuProductDynamicDataList) {
    mpddOrderChanges.forEach((change) => state.frontMenuProductDynamicDataList.editOrder(change));
    mpddSpecialChanges.forEach((change) => state.frontMenuProductDynamicDataList.editSpecial(change));
    mpddIsVisibleChanges.forEach((change) => state.frontMenuProductDynamicDataList.editIsVisible(change));
  }
};

const resetData = (state) => {
  state.frontMenuProductDynamicDataList = null;
};

const noAction = () => {
};

export const mutations = {
  [MutationTypes.GET_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS]: menuProductDynamicDataListSuccess,
  [MutationTypes.UPDATE_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS]: noAction,
  [MutationTypes.APPLY_MENU_PRODUCT_DYNAMIC_DATA_LIST_CHANGES]: applyChanges,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
